module.exports = __webpack_public_path__ + "static/media/Avatars_Other-06.70d90f69.png";